import React from 'react'
import PropTypes from "prop-types"
import {connect} from 'react-redux'
import {hideModal, POPOVER, defaultZindex} from '../../../modules/modals'


let Popover = ({zIndex = defaultZindex, title, content, style = {}, okCB, okButtonTxt, cancelCB, hideModal}, {formatMessage}) => (
    <div className="popover qbm-popover" style = {{zIndex, ...style}}>
        <button
            type="button"
            className="close"
            data-dismiss="popover"
            aria-label="Close"
            onClick={() => typeof cancelCB === 'function' ? cancelCB() : hideModal({modalType:POPOVER})}
        >
            <span aria-hidden="true">×</span>
        </button>
        {
            title &&
            <h3 className="popover-title">{formatMessage(title)}</h3>
        }
        {
            content &&
            <div className="popover-content">
                <p>{formatMessage(content)}</p>
            </div>
        }
        <div className="popover-footer">
            <button
                onClick={okCB}
                type="button"
                className="qbm-popover__button"
            >{formatMessage(okButtonTxt)}</button>
        </div>
    </div>
)

Popover.contextTypes = {formatMessage: PropTypes.func}


export default connect(
    null,
    {hideModal}
)(Popover)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/modals/common/Popover.js